<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-16 13:10:28
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-29 20:36:33
 * @FilePath: /jy-dashboard-web/src/components/productionManagement/component-jxjggl.vue
 * @Description: 描述
-->
<template>
  <div class="jxjggl">
    <div class="content">
      <div class="scroll-list" style="height: 376px" v-if="!loading.jggl">
        <vue-seamless-scroll :class-option="classOption" :data="jggl[1].data">
          <component-scx :data="jggl[1].data" />
        </vue-seamless-scroll>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  computed: {
    ...mapState('production-management', ['loading', 'jggl']),
    classOption () {
      return {
        limitMoveNum: true,
        // 速度
        step: 1,
        // 鼠标停止
        hoverStop: true,
        // 0 下 1 上 2 左 3 右
        direction: 1,
        singleHeight: 210,
        waitTime: 5000
      }
    }
  },
  methods: {
    ...mapActions('production-management', ['getJGGL'])
  },
  created () {
    this.getJGGL()
  }
}
</script>

<style lang="scss">
.jxjggl {
  padding-top: 52px;
  .content {
    padding: 10px 25px;
    height: 100%;
    position: relative;
    .scroll-list {
      overflow: hidden;
      .list-item {
        height: 30px;
        line-height: 30px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
}
</style>
